import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ClientPolicyModel extends BaseModel {
  static urlPath = "client_policy";

  @attr("number") relatedCase;
  @attr("number") policyLimitSelection;
  @attr("number") uninsuredMotoristSelection;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("string") medicalLimit;
  @attr("string") individualPolicyLimit;
  @attr("string") incidentPolicyLimit;
  @attr("string") umbrellaPolicyLimit;
  @attr("string") uninsuredMotoristIndividual;
  @attr("string") uninsuredMotoristIncident;
  @attr("string") medicalPay;
  @attr("string") personalInjuryProtection;
  @belongsTo("user") updatedBy;
  @belongsTo("user") createdBy;
}
